"use client"

import { ArrowDownwardIcon, ArrowUpwardIcon, IconProps } from "@tc/ui-dfe/icons"
import { ComponentType, Fragment, MouseEvent, useState } from "react"
import { Button } from "./Button"
import { ButtonPoper } from "./ButtonPoper"

export type SortOrder = "asc" | "desc"

export const Asc = "asc"

export const Desc = "desc"

export interface SortDetail {
  id: string
  order: SortOrder
  label: string
}

export interface SorterProps {
  label: string
  sortDetails: SortDetail[]
  defaultSortIndex: number
  onSort: (index: number) => void
  dividerIndexes?: number[]
}

export const Sorter = ({
  label,
  sortDetails,
  defaultSortIndex,
  onSort,
  dividerIndexes = [],
}: SorterProps) => {
  function onOptionClick(index: number) {
    onSort(index)
    setSelectedIndex(index)
  }

  function onClick(event: MouseEvent<HTMLElement>) {
    if (!anchorEl) {
      setAnchorEl(event.currentTarget)
    }

    setIsOpen((isOpen) => !isOpen)
  }

  function onClickAway(event: Event) {
    if (anchorEl && anchorEl.contains(event.target as HTMLElement)) {
      return
    }
    setIsOpen(false)
  }

  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined)
  const [selectedIndex, setSelectedIndex] = useState<number>(defaultSortIndex)

  const currentSort = sortDetails[selectedIndex]
  return (
    <Fragment>
      <Button
        data-testid="test-buttonSorter-button"
        ariaLabel="sorter"
        variant="outlined"
        color="secondary"
        onClick={onClick}
        sx={{ height: 40 }}
        startIcon={
          currentSort?.order === "desc" ? (
            <ArrowDownwardIcon />
          ) : (
            <ArrowUpwardIcon />
          )
        }
      >
        {label}
      </Button>
      <ButtonPoper
        data-testid="test-buttonSorter-poper"
        isOpen={isOpen}
        anchorEl={anchorEl as HTMLElement}
        options={sortDetails.map((d) => ({
          value: d.label,
          icon: (d.order === "desc"
            ? ArrowDownwardIcon
            : ArrowUpwardIcon) as ComponentType<IconProps>,
        }))}
        dividerIndexes={dividerIndexes}
        selectedIndex={selectedIndex as number}
        onOptionClick={onOptionClick}
        onClickAway={onClickAway}
      />
    </Fragment>
  )
}
